import { FC } from 'react';

import * as Colors from '../../theme/colors';

type CriticalProps = {
  width?: string;
  color?: string;
};

export const Critical: FC<CriticalProps> = ({ width, color }) => (
  <svg
    role="img"
    aria-labelledby="title"
    width={width ?? '24px'}
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <title id="title">Critical</title>
    <path
      d="M12 20.5858L3.41421 12L12 3.41421L20.5858 12L12 20.5858Z"
      fill={color ?? Colors.critical.primary}
      stroke={color ?? Colors.critical.primary}
      strokeWidth="2"
    />
    <path d="M12 8V13" stroke="white" strokeWidth="2" />
    <path d="M12 14V16" stroke="white" strokeWidth="2" />
  </svg>
);
